import { ApiError } from './api';

/** Only an explicit HTTP 429 before a key read is safe to repeat. Never wrap a
 * message POST, an ambiguous network error or a successful key-bundle response.
 * One shared retry budget bounds the entire encryption preparation. */
export async function rateLimitedRead<T>(read: () => Promise<T>, budget: { used: boolean },
  current: () => boolean = () => true,
  wait: (ms: number) => Promise<void> = ms => new Promise(resolve => setTimeout(resolve, ms)),
): Promise<T> {
  if (!current()) throw new Error('Message preparation cancelled');
  try { return await read(); } catch (error) {
    const seconds = error instanceof ApiError ? error.retryAfterSeconds : null;
    if (!(error instanceof ApiError) || error.status !== 429 || budget.used
      || seconds == null || seconds < 1 || seconds > 60 || !current()) throw error;
    budget.used = true;
    await wait(seconds * 1000);
    if (!current()) throw new Error('Message preparation cancelled');
    return read();
  }
}
